const e = {
  palette: {
    light: {
      blue: "#ACE3FF",
      green: "#BCF1CA",
      grey: "#dfe6ebff",
      purple: "#DDCCFF",
      red: "#FFAFB1",
      yellow: "#FFE258",
      teal: "#A8F0EC",
      pink: "#FFCAFE",
      orange: "#FFBE6B"
    },
    dark: {
      blue: "#13AFFF",
      green: "#3DD766",
      grey: "#7e8e9eff",
      purple: "#7733FF",
      red: "#FF161C",
      yellow: "#BE9D00",
      teal: "#74B9B6",
      pink: "#CB7ACA",
      orange: "#C78B3D"
    }
  },
  color: {
    background: "#ffffffff",
    text: "#314351ff",
    showAll: {
      text: "#314351ff",
      border: "#dfe6ebff",
      bg: "#dfe6ebff"
    },
    clearAll: "#7e8e9eff",
    clearAllHover: "#556575ff"
  }
};
export {
  e as tag
};
